import { Stack, styled } from "@mui/material";
import PersonalizedTag from "../../../common/Personalized/PersonalizedTag";
import { insertPersonalizedTag } from "../../../helpers/utils/insertPersonalizedTag";
import { DOCUMENT_TEMPLATE_TAGS } from "../../../helpers/constant/documentTemplateTagConstant";

const StyledToolbar = styled("div")(() => ({
  border: "1px solid #eee !important",
  paddingTop: "12px !important",
  paddingBottom: "12px !important",
  display: "flex",
  justifyContent: "center",
  gap: 10,
  background: "white",
  borderRadius: "0px !important",
  borderRight: "0px !important",
  borderLeft: "0px !important",
  width: "100%",
  "& .toolbar-large-button": {
    borderRadius: 4,
  },
}));

const CustomToolbar = ({ quillRef, onChange = () => {} }) => {
  return (
    <StyledToolbar id="toolbar">
      <Stack direction={"row"} gap={0.5} alignItems={"center"}>
        <button className="ql-bold"></button>
        <button className="ql-italic"></button>
        <button className="ql-underline"></button>
        <button className="ql-strike"></button>
      </Stack>

      <Stack direction={"row"} gap={0.5} alignItems={"center"}>
        <button className="ql-header" value="1"></button>
        <button className="ql-header" value="2"></button>
      </Stack>
      <Stack direction={"row"} gap={0.5} alignItems={"center"}>
        <button className="ql-list" value="ordered"></button>
        <button className="ql-list" value="bullet"></button>
        <button className="ql-list" value="check"></button>
      </Stack>
      <Stack direction={"row"} gap={0.5} alignItems={"center"}>
        <button className="ql-script" value="sub"></button>
        <button className="ql-script" value="super"></button>

        <button className="ql-indent" value="-1"></button>
        <button className="ql-indent" value="+1"></button>

        <button className="ql-direction" value="rtl"></button>
      </Stack>

      <Stack direction={"row"} gap={0.5} alignItems={"center"}>
        <button className="ql-link"></button>
        <button className="ql-image"></button>
        <button className="ql-blockquote"></button>
      </Stack>

      <Stack direction={"row"} gap={0.5} alignItems={"center"}>
        <select className="ql-align"></select>
        <select className="ql-color"></select>
        <select className="ql-background"></select>
      </Stack>
      <Stack direction={"row"} gap={0.5} alignItems={"center"}>
        <select className="ql-size toolbar-large-button">
          <option value="small"></option>
          <option selected></option>
          <option value="large"></option>
          <option value="huge"></option>
        </select>
        {/*<button className='ql-gpt toolbar-large-button' style={{ width: 'max-content' }}>*/}
        {/*    /!*<ChatGptIcon />*!/Content AI*/}
        {/*</button>*/}
      </Stack>
      <Stack direction={"row"} spacing={1} alignItems={"center"}>
        <PersonalizedTag onClick={(personalizedTag) => insertPersonalizedTag(personalizedTag, quillRef, (value) => onChange(value))} personalizeTagList={DOCUMENT_TEMPLATE_TAGS} />
      </Stack>
    </StyledToolbar>
  );
};

export default CustomToolbar;
